











































import {
  MANAGE_SPACE_OPTIONS,
  MANAGE_TYPE_OPTIONS,
} from "@/resources/constants/sidebarMenu";
import { Component, Vue, Prop } from "vue-property-decorator";
@Component({
  name: "super-space-card-component",
})
export default class SuperSpaceCardComponent extends Vue {
  @Prop() superSpace;
  showActions = false;
  openManageSpace(): void {
    this.$store.dispatch("SuperSpaceStore/getSuperSpaceByIdAction", {
      superSpaceId: this.superSpace.id,
      callback: (data) => {
        this.$store.dispatch("FloatMenuStore/setManageSpaceAction", true);
        this.$store.dispatch(
          "SystemStore/setManageSpaceMenuActiveAction",
          MANAGE_SPACE_OPTIONS.MULTI_SPACE_CUSTOMIZE
        );
        this.$store.dispatch(
          "SystemStore/setManageModalTypeAction",
          MANAGE_TYPE_OPTIONS.CAMPUS
        );
      },
    });
  }
  openSuperSpace(superSpaces): void {
    this.$router.push({ path: `spaces/${superSpaces.id}` });
  }
}
